import { Typography } from '@mui/material'

interface Props {
  utilizationPct: number
  consumedTeu: number
  totalTeu: number
}

export const IssueCardCapacitySummary = ({ utilizationPct, consumedTeu, totalTeu }: Props) => (
  <Typography variant='caption'>
    {utilizationPct}% — {consumedTeu}/{totalTeu} TEU
  </Typography>
)
